import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const tokens = {
  get: () => localStorage.getItem("fra_token"),
  set: (t) => localStorage.setItem("fra_token", t),
  clear: () => localStorage.removeItem("fra_token"),
  admin: {
    get: () => localStorage.getItem("fra_admin_token"),
    set: (t) => localStorage.setItem("fra_admin_token", t),
    clear: () => localStorage.removeItem("fra_admin_token"),
  },
};

const authHeader = (admin) => {
  const t = admin ? tokens.admin.get() : tokens.get();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const api = {
  get: (p, admin) => axios.get(`${API}${p}`, { headers: authHeader(admin) }).then((r) => r.data),
  post: (p, body, admin) => axios.post(`${API}${p}`, body, { headers: authHeader(admin) }).then((r) => r.data),
  put: (p, body, admin) => axios.put(`${API}${p}`, body, { headers: authHeader(admin) }).then((r) => r.data),
  del: (p, admin) => axios.delete(`${API}${p}`, { headers: authHeader(admin) }).then((r) => r.data),
};

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";

// Billing diagnostics are noisy and only useful while developing; keep production consoles clean.
const debug = process.env.NODE_ENV !== "production"
  ? (...args) => console.info(...args)
  : () => {};

/**
 * Stripe pages refuse to be framed (X-Frame-Options), so a plain location change
 * inside an iframe (preview shell, in-app browsers) renders a blank page.
 * Escape to the top-level window, then fall back to a new tab.
 */
export const openStripe = (url) => {
  const framed = window.self !== window.top;
  debug("[billing] opening Stripe", { url, framed });
  if (!framed) {
    window.location.assign(url);
    return true;
  }
  try {
    window.top.location.href = url;
    debug("[billing] navigated top window");
    return true;
  } catch (e) {
    debug("[billing] top navigation blocked, opening new tab", e);
  }
  const tab = window.open(url, "_blank", "noopener,noreferrer");
  if (tab) return true;
  // A blocked popup is a real dead end for the user, so this one always reports.
  console.error("[billing] popup blocked; Stripe could not be opened");
  return false;
};

export const STATES = ["VIC", "NSW", "QLD", "WA", "SA", "TAS", "ACT", "NT"];
export const ALLERGENS = ["Peanut", "Milk", "Egg", "Gluten", "Tree nuts", "Soy", "Sesame", "Fish", "Shellfish", "Lupin"];
export const ALERT_TYPES = [
  { key: "all", label: "All recalls" },
  { key: "allergen", label: "Allergens" },
  { key: "microbial", label: "Contamination / food safety" },
  { key: "foreign_matter", label: "Foreign matter" },
  { key: "other", label: "Other recalls" },
];
export const TYPE_LABEL = {
  allergen: "Allergen", microbial: "Contamination", foreign_matter: "Foreign matter",
  chemical: "Chemical", labelling: "Labelling", other: "Other",
};

export const fmtDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};
